/*
 *公共方法
 *ajax
 *
 *
 */
const config = require("../../config");
import axios from "axios";
import qs from "qs";
import { BASE_CONFIG } from "@/config/config";
import { SERVICE_CODE, STATE_CODE } from "@/config/interface";
import CryptoJS from "crypto-js";
import { MessageBox } from "element-ui";
import { noRepeatMessage as Message } from "@/utils/resetMessage";

let Common = {
  request(
    txCode,
    reqParams,
    callback,
    errorCallback,
    loadingStartCallback,
    loadingEndCallback
  ) {
    let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    let isIE =
      userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
    let isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    let isIE11 =
      userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
    let IE = false;
    if (isIE || isEdge || isIE11) {
      IE = true;
    } else {
      IE = false; //不是ie浏览器
    }

    //判断是否有权限
    let limitTxCode = sessionStorage.getItem("limitTxCode") || "[]";
    limitTxCode = JSON.parse(limitTxCode);

    for (let i = 0; i < limitTxCode.length; i++) {
      let limit = limitTxCode[i];
      if (limit.code.indexOf(txCode) > -1) {
        MessageBox.alert("您没有权限执行此操作。", "权限限制", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          callback() {}
        });
        return false;
      }
    }

    if (typeof loadingStartCallback == "function") {
      loadingStartCallback();
    }
    let self = this;
    let date = new Date();
    let seperator1 = "-";
    let seperator2 = ":";
    let month = (date.getMonth() + 1).toString();
    let strDate = date.getDate().toString();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    let currentdate =
      date.getFullYear() +
      month +
      strDate +
      date.getHours() +
      date.getMinutes() +
      date.getSeconds();
    let currentTenantId = "/vW0BLN5Zhk4QjB9rPTYE6ccLzk9ATt7PLHbsr7dmmU=";
    let params = {
      txCode: txCode || "000000",
      deviceId: "",
      sessionId: "",
      custId: "ZKY4586633",
      currentTenantId: currentTenantId,
      timestamp: currentdate || "",
      reqParams: reqParams || {}
    };

    // 加密
    let cryptoParams = JSON.stringify(params);
    cryptoParams = CryptoJS.enc.Utf8.parse(cryptoParams);

    let key = CryptoJS.enc.Utf8.parse(BASE_CONFIG.CRYPTO_KEY);
    let iv = CryptoJS.enc.Utf8.parse(BASE_CONFIG.CRYPTO_KEY);
    let encrypted = CryptoJS.AES.encrypt(cryptoParams, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC
    });

    let requestDone = false;

    //post 参数
    let postData = qs.stringify({
      jsonparams: BASE_CONFIG.CRYPTO_KEY_OPEN
        ? encrypted.toString()
        : JSON.stringify(params)
    });
    let baseUrl = BASE_CONFIG.SERVICE_ADDRESS;
    if(['10100000','11310001','11310002','11310003','11310004','0900001','2030008'].includes(txCode)) {
      baseUrl = BASE_CONFIG.OFFICIAL_CONFIG_URL
    }

    let promise = axios({
      method: "POST",
      headers: {
        "Content-type": "application/x-www-form-urlencoded"
      },
      url: baseUrl,
      // url:  '/front/mainactivity',
      timeout: BASE_CONFIG.REQUEST_TIMEOUT,
      // params: {
      //     jsonparams: BASE_CONFIG.CRYPTO_KEY_OPEN ? encrypted.toString() : params
      // },
      data: postData,
      withCredentials: true
    });
    promise.then(doneCallbacks, failCallbacks);

    function doneCallbacks(resp) {
      if (typeof loadingEndCallback == "function") {
        loadingEndCallback();
      }
      requestDone = true;
      let data = resp.data;
      //缓存里更新最新的系统时间
      localStorage.setItem("systemTime", data.systemTime);
      if (data) {
        if (data.respCode == STATE_CODE.CORRECT_CODE) {
          if (STATE_CODE.ERROR_CODE.test(data.respData.respCode)) {
            typeof errorCallback === "function" && errorCallback(data);
          } else {
            typeof callback === "function" && callback(data);
          }
        } else {
          if (STATE_CODE.ERROR_CODE.test(data.respCode)) {
            //接口白名单 哪些页面不要报这么严重的错误
            Message.error("系统错误");
            typeof errorCallback === "function" && errorCallback(data);
          } else if (
            data.respCode == STATE_CODE.SESSION_TIMEOUT_CODE ||
            data.respCode == STATE_CODE.HAS_LOGIN_CODE
          ) {
            //  登录异常 跳转到登录页
            data.respMsg && Message.info(data.respMsg);
            if (IE) {
              let s = setTimeout(() => {
                clearTimeout(s);
                window.location.href = baseUrl === BASE_CONFIG.SERVICE_ADDRESS? BASE_CONFIG.ROOT_URL + "/#/" : BASE_CONFIG.ROOT_URL + "/#/login";
                window.location.reload();
              }, 1000);
            } else {
              window.location.href = baseUrl === BASE_CONFIG.SERVICE_ADDRESS ? "#/" : "#/login";
            }
          } else if (data.respCode == STATE_CODE.RIGHT_LIMITE_CODE) {
            //  没有操作权限 跳转提示
            MessageBox.alert("您没有权限执行此操作。", "权限限制", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              center: true,
              callback() {}
            });

            typeof errorCallback === "function" && errorCallback(data);
          } else {
            typeof errorCallback === "function" && errorCallback(data);
          }
        }
      } else {
        typeof errorCallback === "function" && errorCallback(data);
        console.log("返回错误，999");
      }
    }

    function failCallbacks(resp) {
      requestDone = true;
      if (typeof loadingEndCallback == "function") {
        loadingEndCallback();
      }

      let respStr = resp.toString();
      if (respStr.indexOf("Network Error") > -1) {
        Message.error("网络连接失败，请检查网络连接！");
      } else {
        Message.error("系统错误");
        typeof errorCallback === "function" && errorCallback(errorType);
      }
    }
    setTimeout(function() {
      if (!requestDone) {
        if (typeof loadingEndCallback == "function") {
          loadingEndCallback();
        }
      }
    }, BASE_CONFIG.REQUEST_TIMEOUT);
  }
};

export { Common };



// WEBPACK FOOTER //
// ./src/utils/http.js